/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.0.0
 */
import { memo } from 'react';

import ICommonTranslation from '../../modules/internationalization/types/common';
import {
    ModalPopupContainerStyled,
    ModalPopupControlContainer,
    ModalPopupTextStyled,
    ModalPopupTitleStyled,
} from '../../modules/modal/components/styled/ModalStyled';
import { Button, LinkBlock } from '../common';

export interface IContextHelp {
    closeBtn: string;
    handleClose: () => void;
    isOpen: boolean;
    link?: string;
    text: string;
    title: string;
    translations?: ICommonTranslation;
}

const HintPopup = (props: IContextHelp) => {
    return (
        <ModalPopupContainerStyled
            data-component={'modal-popup'}
            data-name={'hint-popup'}>
            <ModalPopupTitleStyled data-name='modal-popup-title'>
                {props.title}
            </ModalPopupTitleStyled>
            <ModalPopupTextStyled data-name='modal-popup-text'>
                {props.text}
            </ModalPopupTextStyled>
            <ModalPopupTextStyled data-name='modal-popup-link'>
                <LinkBlock isExternalUrl={true}
                           url={props.translations && props.translations.contextHelpLink}>{props.link}</LinkBlock>
            </ModalPopupTextStyled>
            <ModalPopupControlContainer>
                <Button
                    className="context-help__close-button"
                    data-name='close-button'
                    kind="mediumNormal"
                    onClick={props.handleClose}
                >
                    {props.closeBtn}
                </Button>
            </ModalPopupControlContainer>
        </ModalPopupContainerStyled>
    );
};

export default memo(HintPopup);
